import * as React from 'react';
import { Dialog, DialogType, DialogFooter } from '@fluentui/react/lib/Dialog';
import { DefaultButton } from '@fluentui/react/lib/Button';
import { ContextualMenu } from '@fluentui/react/lib/ContextualMenu';
import { Text, Link } from '@fluentui/react';
import TimeTaxSupportSystemClient from '../../system';
import MessageCourier from '../../lib/MessageCourier';
import SystemDocumentType from '../../system/documents/SystemDocumentType';
import { useTranslation } from 'react-i18next';
import Project from '../../system/projects/Project';
import { ProjectDocumentControl } from '../../system/projects/ProjectsSystem';
import { ProjectRelatedDocument } from '../../system/documents/ProjectRelatedDocument';
import AssignDocumentForDocumentControlRequeriment from './AssignDocumentForDocumentControlRequeriment';

interface AssignDocumentControlRequeriementDialogProps {
  showDialog: boolean;
  toggleShowDialog: () => void;
  goToConfigProject: () => void;
  system: TimeTaxSupportSystemClient;
  courier: MessageCourier;
  documentSelectedName: string;
  documentSelectedType: SystemDocumentType;
  isService: boolean;
  project: Project;
  document: ProjectRelatedDocument;
  refresh: () => void;
}

const AssignDocumentControlRequeriementDialog = (props: AssignDocumentControlRequeriementDialogProps) => {
  const { t } = useTranslation();
  const [projectDocumentControls, setProjectDocumentControls] = React.useState<ProjectDocumentControl[]>([]);
  const [loadingProjectDocumentControls, setLoadingProjectDocumentControls] = React.useState(false);

  const dragOptions = {
    moveMenuItemText: t('Move'),
    closeMenuItemText: t('Close'),
    menu: ContextualMenu,
  };

  const modalProps = {
    isBlocking: true,
    // styles: modalPropsStyles,
    dragOptions: dragOptions,
  };

  const dialogContentProps = React.useMemo(() => {
    return {
      type: DialogType.normal,
      title: t('Documentos obligatorios'),
    };
  }, [t]);

  React.useEffect(() => {
    (async () => {
      try {
        setLoadingProjectDocumentControls(true);
        const values = await props.system.getProjectSystem().getListControlDocumentarioByCodProject(props.project.getCode());
        setProjectDocumentControls(values);
      } catch (error) {
        console.log(error);
      } finally {
        setLoadingProjectDocumentControls(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.project]);

  return (
    <>
      <Dialog
        hidden={!props.showDialog}
        onDismiss={() => {
          props.toggleShowDialog();
        }}
        dialogContentProps={dialogContentProps}
        modalProps={modalProps}
        maxWidth={900}
        styles={{
          main: {
            minWidth: '95%',
          },
        }}
      >
        <div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <Text variant="mediumPlus">{t('Selecciona a que documento obligatorio corresponde')}</Text>
            </div>
            <div className="ms-Grid-col ms-sm12">
              <Text variant="medium">
                <span className="fw-500">
                  {props.documentSelectedType.getName()} - {props.documentSelectedName}
                </span>
              </Text>
            </div>
          </div>

          <AssignDocumentForDocumentControlRequeriment
            courier={props.courier}
            document={props.document}
            loadingProjectDocumentControls={loadingProjectDocumentControls}
            onCloseModal={props.toggleShowDialog}
            project={props.project}
            projectDocumentControls={projectDocumentControls}
            system={props.system}
            refresh={props.refresh}
          />

          {!loadingProjectDocumentControls && !projectDocumentControls.length && (
            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm12">
                <Text variant="mediumPlus">
                  <span className="">
                    {t('Tu proyecto no tiene ningún documento obligatorio.')} <Link onClick={props.goToConfigProject}>{t('¿Quieres cargar un documento obligatorio?')}</Link>
                  </span>
                </Text>
              </div>
            </div>
          )}
        </div>

        <DialogFooter>
          <DefaultButton
            onClick={() => {
              props.toggleShowDialog();
            }}
            text={t('Cancelar')}
          />
        </DialogFooter>
      </Dialog>
    </>
  );
};

export default AssignDocumentControlRequeriementDialog;
